void (function () {
  const processSectionExists = document.querySelector('.ProcessSection')
  const main = document.querySelector('main')
  if (processSectionExists && main) {
    main.classList.add('f-overflow')
  }
})()
